import { useFilterBarHeight } from 'src/components/molecules/FilterBarContainer/styles';

const PAGE_CHROME_HEIGHT = '170px';

export const useMaximumChartHeight = () => {
  const filterBarHeight = useFilterBarHeight();

  return `calc(100vh - ${filterBarHeight} - ${PAGE_CHROME_HEIGHT})`;
};
